const contentData = [
  {
    title: "Report, Comment, and Upvote AI Hallucinations",
    brain: "https://auth0.com/docs/connections",
    description:
      "Report Hallucinations via our chatbot for inaccurate responses and upvote hallucinations or comment on hallucinations publicly reported. This will allow both AI companies and users insight into the accuracy of answers providing users the mindset of analyze and validate AI responses."
  },
  {
    title: "Report, Comment, and Upvote Copyright Issues",
    copyright: "https://auth0.com/docs/multifactor-authentication",
    description:
      "Report copyright issues via our chatbot with the ability to provide more accurate data sources. This will allow both AI companies and users insight into the accuracy of where models are deriving each data set providing AI companies the ability to update them accordingly if decided."
  },
  {
    title: "Report, Comment, and Upvote Security Issues",
    lock: "https://auth0.com/docs/anomaly-detection",
    description:
      "Report security issues via our chatbot with the ability to submit privately to specific users or report publicly."
  },
  {
    title: "Learn About  examples of AI Hallucinations, Copyright or Security Issues.",
    link: "https://fortune.com/europe/2023/08/08/generative-ai-hallucination-problems-will-companies-move-fast-and-break-things-again/",
    description:
      "Don't take our word for granted, read more from other sources about the issues with AI to learn more about the problems we are solving!"
  }
];

export default contentData;
